import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import MDButton from "components/Basics/MDButton";
import { t } from "i18next";

export default function ConfirmDialog({
	open,
	handleClose,
	handleConfirm,
	title,
	content,
	isDelete,
	concelText = t("COMMON.cancel"),
	confirmText = t("COMMON.confirm")
}) {
	return (
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">{content}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={handleClose}>
					{concelText}
				</MDButton>
				<MDButton variant="contained" color={isDelete ? "error" : "info"} onClick={handleConfirm}>
					{confirmText}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
}
